import { useState } from "react";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabPanel from "04UserPages/99Parts/TabPanel";
import { styled } from "@mui/material";

const TabBarStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

interface TabBarProps {
  tabLabels: string[];
  children: React.ReactNode[];
}

const TabBar: React.FC<TabBarProps> = ({ tabLabels, children }) => {
  const [value, setValue] = useState(0);

  const handleChange = (e: any, newValue: number) => {
    setValue(newValue);
  };

  return (
    <TabBarStyle>
      <Paper square>
        <Tabs value={value} onChange={handleChange}>
          {tabLabels.map((tabLabel) => {
            return <Tab key={tabLabel} label={tabLabel} />;
          })}
        </Tabs>
      </Paper>
      {tabLabels.map((tabLabel, idx) => {
        return (
          <TabPanel key={tabLabel} value={value} index={idx}>
            {children[idx]}
          </TabPanel>
        );
      })}
    </TabBarStyle>
  );
};

export default TabBar;
